import React from 'react'
import TopBar from '../components/TopBar';
import Scanner3 from '../components/queue/Scanner3';
import { useEffect } from 'react';
import { toast } from '../utils/toast';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';

export default function QrLogin() {
  const [start, setStart] = React.useState(false)
  const [scanResult, setScanResult] = React.useState('');
  let store = useSelector((state) => state.loginUser);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const startStop = () => {
    setStart(!start)
  }
  const handleScanResult = (data) => {
    setScanResult(data);
  };

  useEffect(() => {
    if (store?.data?.success) {
      toast.success('Login Successful');
      navigate('/predashboard');
      setStart(!start);
    } else if (store?.error) {
      toast.error(store.error?.message);
    }
    console.log('store', store);
    if (store?.error?.todo === 'verify_otp') {
      swal({
        text: "You are not registered or you need to verify your phone number.",
        title: "Please register first !",
        icon: "warning",
      }).then((value) => {
        if (value) {
          navigate("/verify", { state: scanResult });
        }
      });
    }
  }, [store?.data?.success, store?.error]);

  return (
    <div className='min-h-screen bg-gradient-to-br from-gray-50 to-gray-100'>
      <TopBar title={'QR Code Scanner'} url={-1} />
      
      <div className='flex justify-center items-start px-4 py-6 sm:py-8'>
        <div className='w-full max-w-md'>
          <div className='bg-white rounded-2xl shadow-xl p-6 sm:p-8 mb-6'>
            <div className='text-center mb-6'>
              <div className='w-16 h-16 bg-primary100 rounded-full flex items-center justify-center mx-auto mb-4'>
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V6a1 1 0 00-1-1H5a1 1 0 00-1 1v1a1 1 0 001 1zm12 0h2a1 1 0 001-1V6a1 1 0 00-1-1h-2a1 1 0 00-1 1v1a1 1 0 001 1zM5 20h2a1 1 0 001-1v-1a1 1 0 00-1-1H5a1 1 0 00-1 1v1a1 1 0 001 1z" />
                </svg>
              </div>
              <h1 className='text-2xl sm:text-3xl font-bold text-gray-800 mb-2'>
                QR Code Login
              </h1>
              <p className='text-gray-600 text-sm sm:text-base leading-relaxed'>
                Scan your QR code for quick and secure access to your healthcare portal
              </p>
            </div>

            <div className='bg-amber-50 border border-amber-200 rounded-xl p-4 mb-6'>
              <div className='flex items-start space-x-3'>
                <div className='flex-shrink-0'>
                  <svg className="w-5 h-5 text-amber-600 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <p className='text-amber-800 text-sm font-medium'>Registration Required</p>
                  <p className='text-amber-700 text-xs mt-1'>You must be registered to log in with a QR code</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center space-y-6">
              <button 
                onClick={startStop} 
                className={`w-full sm:w-4/5 py-4 px-6 rounded-xl font-semibold text-white transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-lg ${
                  start 
                    ? 'bg-red-500 hover:bg-red-600 shadow-red-200' 
                    : 'bg-primary100 hover:bg-primary100/90 shadow-primary100/20'
                }`}
              >
                <div className='flex items-center justify-center space-x-3'>
                  <span className='text-lg'>
                    {start ? "Stop Scanner" : "Start Scanner"}
                  </span>
                  {start ? (
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V8a1 1 0 00-1-1H8z" clipRule="evenodd" />
                    </svg>
                  ) : (
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                    </svg>
                  )}
                </div>
              </button>

              <div className='w-full flex justify-center'>
                {start ? (
                  <div className='w-full max-w-sm'>
                    <Scanner3
                      setStart={setStart}
                      start={start}
                      type={'login'}
                      onScanResult={handleScanResult}
                    />
                  </div>
                ) : (
                  <div className='bg-gray-50 rounded-xl p-8 border-2 border-dashed border-gray-300 text-center'>
                    <img 
                      className="w-32 h-32 mx-auto opacity-60" 
                      src="./barcode.png" 
                      alt="QR Code Placeholder" 
                    />
                    <p className='text-gray-500 text-sm mt-4'>
                      Tap "Start Scanner" to begin
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className='bg-white rounded-xl shadow-lg p-4'>
            <div className='flex items-center justify-center space-x-6 text-xs text-gray-600'>
              <div className='flex items-center space-x-2'>
                <svg className="w-4 h-4 text-primary100" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                </svg>
                <span>Secure</span>
              </div>
              <div className='flex items-center space-x-2'>
                <svg className="w-4 h-4 text-primary100" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span>Fast Login</span>
              </div>
              <div className='flex items-center space-x-2'>
                <svg className="w-4 h-4 text-primary100" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span>NDPR Compliant</span>
              </div>
            </div>
          </div>

          <div className='text-center mt-6'>
            <p className='text-gray-500 text-sm'>
              Need help? Contact support or try{' '}
              <button 
                onClick={() => navigate('/login')}
                className='text-primary100 hover:text-primary100/80 font-medium underline'
              >
                traditional login
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
